/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Billing_Enable_Desc_EmptyInputs */



/**
* | output |
* | --- |
* | "Nothing has accumulated. Invoicing starts with the current month, which bills at month-end." |
*
* @param {Partner_Admin_Billing_Enable_Desc_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_enable_desc_empty = /** @type {((inputs?: Partner_Admin_Billing_Enable_Desc_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Enable_Desc_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es ist nichts aufgelaufen. Die Abrechnung beginnt mit dem aktuellen Monat, der zum Monatsende fakturiert wird.")
	return /** @type {LocalizedString} */ ("Nothing has accumulated. Invoicing starts with the current month, which bills at month-end.")
});